import { render, staticRenderFns } from "./MapaDeCotacao.vue?vue&type=template&id=25bd3833&"
import script from "./MapaDeCotacao.vue?vue&type=script&lang=js&"
export * from "./MapaDeCotacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports